export const NEW_BILLING_GROUP_ID = 'new_billing_group';
export const NEW_BILLING_GROUP_NAME = 'Create new billing group';
